module.exports = "//static.hsappstatic.net/HubspotToolsMenu/static-1.191/js/sprocket_orange.svg"